module.exports = __webpack_public_path__ + "static/media/IBM_Call.791f0ed0.png";